import { render, staticRenderFns } from "./MonthlySummaryWidgets.vue?vue&type=template&id=70bd5835&scoped=true&"
import script from "./MonthlySummaryWidgets.vue?vue&type=script&lang=js&"
export * from "./MonthlySummaryWidgets.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySummaryWidgets.vue?vue&type=style&index=0&id=70bd5835&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd5835",
  null
  
)

export default component.exports